"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCT_AGGREGATED_ATTRIBUTE_VALUES_PAGINATION = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_PRODUCT_AGGREGATED_ATTRIBUTE_VALUES_PAGINATION = (0, gql_1.gql)(`
  query ProductAggregatedAttributeValuesPagination(
    $ids: [ID!],
    $productTreeId: ID!,
    $attribute: String,
    $productTreeNodeIds: [ID!]
  ) {
    catalogs(ids: $ids) {
      edges {
        node {
          id
          statistics(productTreeNodeIds: $productTreeNodeIds, productTreeId: $productTreeId) {
            attributes(attribute: $attribute, first: 0) {
              edges {
                node {
                  dimensions {
                    productTreeNode {
                      id
                    }
                    attribute
                    value
                  }
                }
              }
              totalCount
              pageInfo {
                endCursor
                hasNextPage
                hasPreviousPage
                startCursor
              }
            }
          }
        }
      }
    }
  }
`);
